let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8WIWL")).then(() => parcelRequire('04V4O'));